import { jsx as C } from "react/jsx-runtime";
const L = (e) => /* @__PURE__ */ C(
  "svg",
  {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ C(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9557 7.27532C13.2475 6.98356 13.2474 6.51053 12.9557 6.21879C12.6639 5.92705 12.1909 5.92707 11.8991 6.21884L6.89455 11.2239L6.89439 11.2241L6.89415 11.2243C6.79233 11.3261 6.71154 11.4469 6.65639 11.5799C6.60118 11.7131 6.57275 11.8558 6.57275 12C6.57275 12.1442 6.60118 12.2869 6.65639 12.4201C6.71154 12.5531 6.79233 12.6739 6.89415 12.7757L6.89455 12.7761L11.8991 17.7812C12.1909 18.0729 12.6639 18.0729 12.9557 17.7812C13.2474 17.4895 13.2475 17.0164 12.9557 16.7247L8.23148 12L12.9557 7.27532ZM18.2086 7.27532C18.5004 6.98356 18.5004 6.51053 18.2086 6.21879C17.9168 5.92705 17.4438 5.92707 17.1521 6.21884L12.1475 11.2239L12.1473 11.2241L12.1471 11.2243C12.0453 11.3261 11.9645 11.4469 11.9093 11.5799C11.8541 11.7131 11.8257 11.8558 11.8257 12C11.8257 12.1442 11.8541 12.2869 11.9093 12.4201C11.9645 12.5531 12.0453 12.6739 12.1471 12.7757L12.1475 12.7761L17.1521 17.7812C17.4438 18.0729 17.9168 18.0729 18.2086 17.7812C18.5004 17.4895 18.5004 17.0164 18.2086 16.7247L13.4844 12L18.2086 7.27532Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  L as SmallDoubleChevronLeft
};
//# sourceMappingURL=SmallDoubleChevronLeft.js.map
